import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteInvoicesMutation} from '../hooks/useInvoicesQuery';

interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

/**
 * Batch delete, behind the shared confirmation button — never a bare delete
 * (§2, DELETE_FUNCTIONALITY_PATTERN).
 *
 * FNP-918: takes the mutation directly instead of instantiating the whole
 * `useInvoices` list hook for one callback. It also AWAITS the mutation before
 * clearing the selection, so a failed delete leaves the rows selected for a
 * retry rather than silently dropping the operator's choice — the previous
 * version called `deleteRecords(ids); onDeleteComplete?.();` synchronously and
 * cleared regardless of outcome.
 */
export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const deleteMutation = useDeleteInvoicesMutation();

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedIds.length === 0 || deleteMutation.isPending}
            recordIdsLength={selectedIds.length}
            handleConfirm={async () => {
                if (selectedIds.length === 0) {
                    return;
                }
                await deleteMutation.mutateAsync(selectedIds);
                onDeleteComplete?.();
            }}
        />
    );
};
